import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { GroundingsListComponent } from 'src/app/modules/groundings/pages/groundings-list/groundings-list.page';
var ɵ0 = {
    permissions: ['canReadDocumentsList']
};
var routes = [
    {
        path: 'list',
        component: GroundingsListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var GroundingsRoutingModule = /** @class */ (function () {
    function GroundingsRoutingModule() {
    }
    return GroundingsRoutingModule;
}());
export { GroundingsRoutingModule };
export { ɵ0 };
